var _style, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialitiesSectionArtMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000039835526939424746230000001260946749667145094_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1466.9 1630.9",
    style: {
      enableBackground: "new 0 0 1466.9 1630.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EC1A15;}\r\n\t.st1{fill:#FEEFE6;}\r\n\t.st2{fill:#D49BA0;}\r\n\t.st3{fill:none;stroke:#F2CDBF;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st4{fill:#F2CDBF;}\r\n\t.st5{fill:#D4A59B;}\r\n\t.st6{fill:#FADED2;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{fill:#F0D3D8;}\r\n\t.st9{fill:#A7C2D9;}\r\n\t.st10{fill:#BF828B;}\r\n\t.st11{fill:#326894;}\r\n\t.st12{fill:#4D8AB3;}\r\n\t.st13{fill:#994403;}\r\n\t.st14{fill:#852E03;}\r\n\t.st15{fill:#732D02;}\r\n\t.st16{fill:#EBF5FF;}\r\n\t.st17{fill:#FBBD9A;}\r\n\t.st18{fill:#F0997F;}\r\n\t.st19{fill:#D43226;}\r\n\t.st20{fill:#002A42;}\r\n\t.st21{fill:#EB4A2A;}\r\n\t.st22{fill:#06384F;}\r\n\t.st23{fill:none;stroke:#27788F;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st24{fill:#8C4206;}\r\n\t.st25{fill:#A66317;}\r\n\t.st26{fill:#2F344D;}\r\n\t.st27{fill:none;stroke:#8C4206;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st28{fill:none;stroke:#D45E4E;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st29{fill:#DE3B26;}\r\n\t.st30{fill:#163649;}\r\n\t.st31{fill:#B82621;}\r\n\t.st32{fill:#FBBD9A;stroke:#D45E4E;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st33{fill:none;stroke:#B82621;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st34{fill:#FDBD9B;}\r\n\t.st35{fill:none;stroke:#B0514A;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st36{fill:#316382;}\r\n\t.st37{fill:#407C91;}\r\n\t.st38{fill:#502202;}\r\n\t.st39{fill:#855321;}\r\n\t.st40{fill:#112C45;}\r\n\t.st41{fill:#163A4A;}\r\n\t.st42{fill:#4B8394;}\r\n\t.st43{fill:#6B4019;}\r\n\t.st44{fill:none;stroke:#502202;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st45{fill:none;stroke:#B0514A;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st46{fill:#2D3A5E;}\r\n\t.st47{fill:#69C5C9;}\r\n\t.st48{fill:none;stroke:#3E7C8A;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st49{fill:#9BEBE7;}\r\n\t.st50{fill:#DAE8F7;}\r\n\t.st51{fill:none;stroke:#B8C8E3;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st52{fill:none;stroke:#163649;stroke-miterlimit:10;}\r\n\t.st53{fill:none;stroke:#163649;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st54{fill:#381B07;}\r\n\t.st55{fill:#DB8E62;}\r\n\t.st56{fill:#1D9FB3;}\r\n\t.st57{fill:#B23F37;}\r\n\t.st58{fill:#678CA8;}\r\n\t.st59{fill:#136D94;}\r\n\t.st60{fill:#CF6E4A;}\r\n\t.st61{fill:#25B2C2;}\r\n\t.st62{fill:#27B8C1;}\r\n\t.st63{fill:none;stroke:#51DBDB;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st64{fill:#D68A5A;}\r\n\t.st65{fill:#24151A;}\r\n\t.st66{fill:none;stroke:#A8473E;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st67{fill:#32C9CF;}\r\n\t.st68{fill:#412408;}\r\n\t.st69{fill:#664216;}\r\n\t.st70{fill:#411F00;}\r\n\t.st71{fill:none;stroke:#412408;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st72{fill:none;stroke:#A8473E;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st73{fill:#FFA8B1;}\r\n\t.st74{fill:#F2E4E5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5,119.2c26,24.6,51.9,49.1,77.9,73.8c22.3-23.5,44.5-46.9,66.9-70.5c-11.8-11-23.6-22-35.6-33.3 c-1.8,1.9-3.5,3.8-5.3,5.5c-8.8,8.9-17.6,17.7-26.4,26.5c-3.9,3.9-9.4,4.1-13,0.4c-3.6-3.6-3.4-9.1,0.5-13 c12.4-12.4,24.7-24.9,37.1-37.3c4.4-4.4,9.3-4.5,13.7-0.3c15.7,14.7,31.4,29.3,47.1,44c4.3,4,4.5,9.3,0.5,13.6 c-26.2,27.6-52.3,55.2-78.5,82.8c-3.7,3.9-9,4-13,0.2c-14.7-13.9-29.3-27.8-44-41.6C34.2,155.7,19.1,141.4,4,127 c-5.1-4.9-5.3-9.7-0.4-14.8c27.9-29.5,55.8-58.9,83.7-88.4c3.5-3.7,7-4.8,10.7-3.3c6,2.3,7.6,9.7,3.2,14.5c-8,8.5-16,17-24.1,25.5 C59,79.5,41,98.5,23,117.6C22.5,118,22.1,118.5,21.5,119.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.9,118c-26-24.6-51.8-49.1-77.9-73.8c-22.3,23.5-44.5,46.9-66.9,70.5c11.9,11.1,23.6,22,35.4,33.1 c0.6-0.5,1.1-1,1.5-1.5c10.1-10.2,20.2-20.4,30.4-30.5c4.3-4.3,10.8-3.8,14,1c2.4,3.5,2,8-1.1,11.3c-2.8,3-5.7,5.8-8.6,8.7 c-9.6,9.7-19.2,19.4-28.8,29c-4.4,4.4-9.3,4.5-13.9,0.2c-15.6-14.6-31.2-29.2-46.8-43.7c-4.6-4.3-4.8-9.4-0.4-14 c25.9-27.4,51.9-54.7,77.9-82.1c4.3-4.5,9.4-4.6,13.9-0.3c29.9,28.3,59.7,56.6,89.6,84.9c4.2,3.9,4.4,9.3,0.4,13.5 c-28.3,29.9-56.7,59.9-85,89.8c-3.8,4-9.3,4.3-13,0.8c-3.7-3.4-3.7-9.1,0.1-13c16.6-17.6,33.3-35.2,49.9-52.7 c9.4-9.9,18.8-19.9,28.2-29.8C207.1,119,207.4,118.6,207.9,118z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.1,224.2c0-6,4.8-10.8,10.7-10.8c5.9,0,10.7,4.8,10.7,10.8s-4.7,10.6-10.8,10.6 C110.7,234.8,106.1,230.2,106.1,224.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.1,10.8C100,4.8,104.8,0,110.8,0s10.8,4.7,10.8,10.7c0,5.9-4.7,10.6-10.6,10.7 C105,21.4,100.2,16.8,100.1,10.8z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1466.9,1519.1H208.8c-115.3,0-208.7-93.5-208.7-208.7V111.8h1258.1c115.3,0,208.7,93.5,208.7,208.7V1519.1z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1251.8,1551.8c16.6-287.8,141.8-323.3,161.5-299C1454.5,1303.5,1311.5,1462.3,1251.8,1551.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1399.7,1264.1c-70.1,81.7-120.1,180.5-144.4,285.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1362.7,1266.6c4.1,12.1,6.3,24.7,6.6,37.4c13.4-2.9,27-4.4,40.7-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1314.5,1316.5c7.9,13.7,13.7,28.5,17.2,43.9c15.9-3.4,32.2-5.1,48.5-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1281.3,1388.8c6.6,10.3,12.2,21.1,16.9,32.4c15.4-6.2,32.1-9.2,48.7-8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1312.7,1458.3c-10.1-0.7-20.3,0-30.2,2.2c-2.6-8.2-6.2-16-10.8-23.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1251.8,1551.8c92-146.5,209.5-194.8,214.8-141.8C1474.1,1483.2,1315.4,1531.1,1251.8,1551.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1452,1415.1c-72.4,34.6-139.5,80.5-197.9,135.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1426,1399.8c0.3,10.2-0.7,20.5-2.9,30.4c10.1,1,19.8,4.9,27.7,11.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1377,1422.5c1.9,10.8,2.7,21.7,2.2,32.6c13.6,1.2,26.9,5.9,38.2,13.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1330.5,1456.2c3.8,8.4,5.5,17.7,5.1,27c12.6,1,24.9,5,35.7,11.5"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1090.4,
    y: 1321.8,
    className: "st4",
    width: 204,
    height: 21.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1288.4,1343.2 1288.4,1551.8 1270.4,1551.8 1270.4,1540.4 1114.4,1540.4 1114.4,1551.8  1096.4,1551.8 1096.4,1343.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1096.4,
    y: 1343.2,
    className: "st5",
    width: 192,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1115.6,
    y: 1361.9,
    className: "st5",
    width: 153,
    height: 46.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114.1,
    y: 1357.6,
    className: "st6",
    width: 156.2,
    height: 46.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1115.6,
    y: 1420.4,
    className: "st5",
    width: 153,
    height: 46.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114.1,
    y: 1416.1,
    className: "st6",
    width: 156.2,
    height: 46.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1115.6,
    y: 1478.9,
    className: "st5",
    width: 153,
    height: 46.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114.1,
    y: 1474.6,
    className: "st6",
    width: 156.2,
    height: 46.4
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1140.5,1311.4v-32.5h8.9v32.5c0,2.2-1.8,3.9-3.9,3.9h-1.1C1142.2,1315.3,1140.5,1313.6,1140.5,1311.4 L1140.5,1311.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1138.9,1277.9L1138.9,1277.9c0-0.6,0.5-1,1-1h10.1c0.6,0,1,0.5,1,1l0,0c0,0.6-0.5,1-1,1h-10.1 C1139.3,1279,1138.9,1278.5,1138.9,1277.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1141.9,1310.9v-21.2h6.1v21.2c0,1.7-1.4,3-3,3l0,0C1143.3,1313.9,1141.9,1312.6,1141.9,1310.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1158.3,1311.4v-32.5h8.9v32.5c0,2.2-1.8,3.9-3.9,3.9h-1.1C1160.1,1315.3,1158.3,1313.6,1158.3,1311.4 L1158.3,1311.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1156.7,1277.9L1156.7,1277.9c0-0.6,0.5-1,1-1h10.1c0.6,0,1,0.5,1,1l0,0c0,0.6-0.5,1-1,1h-10.1 C1157.2,1279,1156.7,1278.5,1156.7,1277.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1159.7,1310.9v-21.2h6.1v21.2c0,1.7-1.4,3-3,3l0,0C1161.1,1313.9,1159.7,1312.6,1159.7,1310.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1177.2,1311.4v-32.5h8.9v32.5c0,2.2-1.8,3.9-3.9,3.9h-1.1C1179,1315.3,1177.2,1313.6,1177.2,1311.4 L1177.2,1311.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1175.6,1277.9L1175.6,1277.9c0-0.6,0.5-1,1-1h10.1c0.6,0,1,0.5,1,1l0,0c0,0.6-0.5,1-1,1h-10.1 C1176.1,1279,1175.6,1278.5,1175.6,1277.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1178.6,1310.9v-21.2h6.1v21.2c0,1.7-1.4,3-3,3l0,0C1180,1313.9,1178.6,1312.6,1178.6,1310.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1196.5,1311.4v-32.5h8.9v32.5c0,2.2-1.8,3.9-3.9,3.9h-1.1C1198.2,1315.3,1196.5,1313.6,1196.5,1311.4 L1196.5,1311.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1194.9,1277.9L1194.9,1277.9c0-0.6,0.5-1,1-1h10.1c0.6,0,1,0.5,1,1l0,0c0,0.6-0.5,1-1,1h-10.1 C1195.3,1279,1194.9,1278.5,1194.9,1277.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1197.9,1310.9v-21.2h6.1v21.2c0,1.7-1.4,3-3,3l0,0C1199.3,1313.9,1197.9,1312.6,1197.9,1310.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1217.2,1311.4v-32.5h8.9v32.5c0,2.2-1.8,3.9-3.9,3.9h-1.1C1218.9,1315.3,1217.2,1313.6,1217.2,1311.4 L1217.2,1311.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1215.6,1277.9L1215.6,1277.9c0-0.6,0.5-1,1-1h10.1c0.6,0,1,0.5,1,1l0,0c0,0.6-0.5,1-1,1h-10.1 C1216,1279,1215.6,1278.5,1215.6,1277.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1218.6,1310.9v-21.2h6.1v21.2c0,1.7-1.4,3-3,3l0,0C1220,1313.9,1218.6,1312.6,1218.6,1310.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1131.7,
    y: 1280.8,
    className: "st9",
    width: 109.8,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1125.9,
    y: 1314.7,
    className: "st2",
    width: 122.7,
    height: 7.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1130.8,
    y: 1276.9,
    className: "st2",
    width: 3.1,
    height: 41.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1239.6,
    y: 1276.9,
    className: "st2",
    width: 3.1,
    height: 41.3
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M682.7,1423.8c25.8-32.4,38.5-75,34.5-116.1s-24.6-80.5-57.4-107.8c0.5,30.5-0.8,61-3.8,91.4 c-2.8,28.9-7.2,58.4-0.3,86.6C659.8,1394.6,667.9,1410.4,682.7,1423.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M680.3,1460.9c0-102,27.1-135-12.6-242.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M686.6,1235.9c-2.8,5.9-5.5,11.8-8.3,17.7c-4.9-2.4-10.3-3.9-15.8-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M659,1297.3c10.4,0.4,20.7,3.2,29.9,8.1c6.1-7.5,13.3-14.1,21.4-19.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M657.8,1346.8c10.4-0.9,21.2,1.9,29.9,7.7c8.5-9,18.3-16.8,28.9-23.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M662.5,1387.6c7.8,0.8,15.3,4.6,20.7,10.3c5.7-7.7,12.6-14.5,20.4-20.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M701.3,1420.7c0,0-22-48.1,6.2-100.7c15.5-29.1,49.1-64.4,91-94c0,0-19.9,108.6-44.7,154 C734.8,1415,701.3,1420.7,701.3,1420.7L701.3,1420.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M783.4,1247.1c-43.3,69.5-74.1,145.4-98.5,223.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M755.9,1264.3c2.6,6,4.7,12.3,6.2,18.7c7.3-1.4,14.8-2.3,22.2-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M721.5,1307.9c6.1,8.6,11,18,14.6,27.9c11.5-5.5,23.8-9.3,36.4-11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M701.3,1344.8c7.4,9.5,13.1,20.5,16.5,32c12.9-5.4,26.4-9.5,40.2-12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M695.8,1389.2c4.3,4.8,8.3,9.8,12,15c9.5-3.9,19.5-6.7,29.6-8.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M659.9,1430.5c0,0,19-27,5-73.8c-19.3-64.2-99.6-109.7-99.6-109.7s21.5,87.8,38.3,131.5 C620.6,1422.7,659.9,1430.5,659.9,1430.5L659.9,1430.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M664.9,1454c0,0-11-88.3-89-194.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M604.2,1277.9c-2.3,5.3-3.8,10.9-4.5,16.7c-5.5-1.5-11.1-2.3-16.8-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M593.9,1337.3c10.6-1.6,21.7-0.9,32,2.2c2-9.5,6.5-18.6,12.9-26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M662,1355.7c-7.3,8-13,17.4-16.7,27.5c-10.1-4.4-21.7-5.1-32.3-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M635.7,1416.3c7-1.3,14.1-1.4,21.1-0.3c2.4-5.6,5.9-10.7,10.2-15"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "733.2,1437.9 730.2,1454.9 726.9,1473.6 725.1,1483.3 721.8,1502 713,1551.8 648.9,1551.8  639.9,1502 636.5,1483.3 634.8,1473.6 631.4,1454.9 628.3,1437.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "730.2,1454.9 726.9,1473.6 634.8,1473.6 631.4,1454.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "725.1,1483.3 721.8,1502 639.9,1502 636.5,1483.3  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 744.9,
    y: 1525.7,
    className: "st11",
    width: 105.1,
    height: 9.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M762.8,1435.3c0,0.2,0,0.5-0.1,0.7l-1.6,13.5l-14.5,120c-0.4,3.2-3.2,5.5-6.4,5.1c-2.9-0.4-5-2.9-5-5.8 c0-0.2,0-0.5,0.1-0.7l14.4-118.5l1.8-14.9c0.4-3.2,3.2-5.5,6.4-5.1C760.7,1429.8,762.8,1432.3,762.8,1435.3L762.8,1435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M762.8,1435.3c0,0.2,0,0.5-0.1,0.7l-1.6,13.5h-11.5l1.8-14.9c0.4-3.2,3.2-5.5,6.4-5.1 C760.7,1429.8,762.8,1432.3,762.8,1435.3L762.8,1435.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M804.6,1434.2v134.5c0,3.2-2.5,5.9-5.7,5.9c-1.6,0-3-0.7-4-1.7c-1-1.1-1.7-2.5-1.7-4.2v-134.5 c0-3.2,2.6-5.9,5.7-5.9c1.6,0,3,0.7,4,1.7S804.6,1432.6,804.6,1434.2L804.6,1434.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M802.9,1430.1c1,1.1,1.7,2.5,1.7,4.2v15.2h-11.4v-15.2c0-3.2,2.6-5.9,5.7-5.9 C800.4,1428.4,801.9,1429,802.9,1430.1L802.9,1430.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M862,1568.7c0,2.9-2.1,5.4-5,5.8c-3.1,0.4-6-1.9-6.4-5.1l-14.5-120l-1.6-13.5c0-0.2-0.1-0.5-0.1-0.7 c0-2.9,2.1-5.4,5-5.8c3.1-0.4,6,1.9,6.4,5.1l1.8,14.9l14.3,118.5C862,1568.2,862,1568.5,862,1568.7L862,1568.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M847.6,1449.5h-11.5l-1.6-13.5c0-0.2-0.1-0.5-0.1-0.7c0-2.9,2.1-5.4,5-5.8c3.1-0.4,6,1.9,6.4,5.1 L847.6,1449.5L847.6,1449.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M872.4,1419.1v3.8c0,6.7-5.4,12.1-12.1,12.1H752.4c-6.7,0-12.1-5.4-12.1-12.1v-3.8 c0-6.7,5.4-12.1,12.1-12.1h107.9C867,1407,872.4,1412.4,872.4,1419.1L872.4,1419.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M872.4,1419.1v3.8c0,6.7-5.4,12.1-12.1,12.1h-98c-6.7,0-12.1-5.4-12.1-12.1v-3.8 c0-6.7,5.4-12.1,12.1-12.1h98C867,1407,872.4,1412.4,872.4,1419.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M759.7,1178.8c-1.4,2.8-2.7,5.5-3.9,8.2c-0.8,4.8-0.3,9.6,0,14.5s0.5,9.8-0.8,14.4 c-1.3,4.6-4.5,9.1-9.2,10.8c-3,1.2-6.6,1.2-9,3.4c-2.6,2.5-2.5,6.7-1.5,10.1c0.8,2.9,2.1,5.8,4.4,7.8c2.3,2,6,3.3,8.5,1.9 c2.5-1.5,5.8-0.4,7.6,1.8c1.8,2.2,2.6,5,4.4,7.3c2.5,3.2,6.7,4.8,10.8,4.9c4.1,0.1,8.5-0.5,11.3-2.2c5.9-3.7,13.2-6.2,19.3-2.7 c3.2,1.8,5.7,4.7,9.1,6c2.9,1.1,6.3,0.9,9.1-0.6s3.8-4.6,5.5-7c3.2-4.4,10.8-0.8,16.2-2.3c5.7-1.6,9.5-7.8,8.2-13.4 c-1.3-5.6-7.5-7.6-13-8.4c-3.8-0.6-5.3-5.4-6.2-9s-0.7-7.4-0.6-11.1c0.3-7.5,3.8-25.2,1.6-27.5c-1.1-1.2-5.4-4.4-7-5.1 c-7.2-3.3-14.3-6.5-21.5-9.8c-6.5-3-13.3-6-20.6-5.8C775.3,1165.5,764.9,1168.3,759.7,1178.8L759.7,1178.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M784.5,1246.8c0,0-31.8,5-35.1,16.3c-3.4,11.3,15.9,90,15.9,90l71.4-4.4c0,0,5.2-90.8-6.2-96.5 C819.2,1246.5,784.5,1246.8,784.5,1246.8L784.5,1246.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M812.3,1249.9c0,0-4.6,15.8-13,19.2c-8.4,3.5-26.8-17.6-26.8-17.6c3.7-2.3,5.1-8,5.6-13.2 c0.5-5.2-0.1-10-0.1-10l25.5,4.9c-0.7,7.9,1.7,12.1,4.1,14.2C809.9,1249.6,812.3,1249.9,812.3,1249.9L812.3,1249.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M807.5,1247.5c-12.1,1.6-23.1-4.5-29.6-9.2c0.5-5.2-0.1-10-0.1-10l25.5,4.9 C802.8,1241.2,805.1,1245.4,807.5,1247.5L807.5,1247.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M881.4,1546c-2.8,4.6-50.5-24.9-50.5-30c0-3.3,6.2-8.1,10.6-11c2.3-1.6,4.1-2.6,4.1-2.6l11.2-5.1 l5,2.7c7.3,12.6,14.3,25.8,17.8,34.9C881.6,1540.3,882.4,1544.3,881.4,1546L881.4,1546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M879.5,1534.9c-13.7,0.6-31.8-21.6-38.1-29.9c2.3-1.6,4.1-2.6,4.1-2.6l11.2-5.1l5,2.7 C869.1,1512.6,876,1525.7,879.5,1534.9L879.5,1534.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M832.2,1355.4c0,0,87,11,90,33.3c3,22.3-54.6,120.5-54.6,120.5l-20.7-5.4l27-87.8l-69.3-29.4l13.8-31.2 L832.2,1355.4L832.2,1355.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M860.3,1548.6c-2.8,4.6-50.5-24.9-50.5-30c0-3.3,6.2-8.1,10.6-11c2.3-1.6,4.1-2.6,4.1-2.6l11.2-5.1 l5,2.7c7.3,12.6,14.3,25.8,17.8,34.9C860.4,1542.8,861.3,1546.9,860.3,1548.6L860.3,1548.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M858.4,1537.4c-13.7,0.6-31.8-21.6-38.1-29.9c2.3-1.6,4.1-2.6,4.1-2.6l11.2-5.1l5,2.7 C847.9,1515.1,854.9,1528.3,858.4,1537.4L858.4,1537.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M758.9,1348c0,0-30.1,59.6,22.9,66c38.5,4.7,64.1,3.7,64.9,5.9c1.3,3.4-25.1,86.7-25.1,86.7l26,8.2 c0,0,53.8-115.5,50.8-125.5c-2.4-8.3-76.6-20.9-76.6-20.9c6.2-3,10.8-13.8,10.2-27.7L758.9,1348L758.9,1348z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M767.2,1342.8c0,0-17.3,38-3.5,53.5c16.3,18.2,87.6,12.3,92.6,18.8c4,5.2-27.5,89.3-27.5,89.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 823.7,
    y1: 1503.1,
    x2: 848.8,
    y2: 1510.7
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M824.5,1201c6.1-0.7,11.5,2.4,12,6.8c0.5,4.4-4,8.7-10.2,9.4c-6.1,0.7-11.5-2.4-12-6.8 C813.8,1206,818.3,1201.7,824.5,1201z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M763.8,1200.6c0-21.2,13.4-38.3,31.5-38.3s32.7,17.2,32.7,38.3s-9.2,39.4-26.2,40 C784.6,1241.3,763.8,1221.8,763.8,1200.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M765.5,1205.5c9.1-4.2,16.5-11.7,19.9-20.9c4.7,5.3,11.5,8.3,18.5,9.6c7,1.3,14.1,1.1,20.8,0.9 c2.2,1.8,3.7,4.4,4.2,7.2c0.8-6.3,0.1-12.7-2-18.7c-18-5.5-35.8-11.3-53.6-17.5C770.7,1178.7,768,1191.4,765.5,1205.5 L765.5,1205.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M782.5,1174.9c3.9,7.3,11.3,12.1,19.2,14.7c7.9,2.5,16.2,2.9,24.6,3.2c1.3,4.6,1.6,10,1.6,14.7 c2.9-6.7,4.4-12.4,4.6-17.9c0.1-1.6,0.1-3.2,0-4.9c-0.4-11.6-5.2-18.3-11.7-23.2c-6.5-5-14.4-7.1-22.6-7.1s-13.2,1.8-16.2,5 c-1.1,1.1-1.9,2.4-2.5,3.8C778.1,1166.2,779.6,1169.5,782.5,1174.9L782.5,1174.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M755.6,1208.1c-0.3-10.3-0.9-28,3.2-36.5c2.7-5.5,7.9-10.1,14-11c6.1-0.8,12.9,3,14.3,9 c-2.7,13.9-9.7,26.7-19.6,36.7C764.1,1207.9,759.1,1209,755.6,1208.1L755.6,1208.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M782,1159.2c11.8-3.2,25.1-0.4,34.8,7c7.6,5.8,13,14.1,15.7,23.2c0.1-1.6,0.1-3.2,0-4.9 c-0.4-11.6-5.2-18.3-11.7-23.2c-6.5-5-14.4-7.1-22.6-7.1S785,1156.1,782,1159.2L782,1159.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M751.8,1208.4c1.1-4.4,6.9-6.7,12.8-5.1c6,1.5,9.9,6.3,8.8,10.7s-6.9,6.7-12.8,5.1 C754.6,1217.5,750.7,1212.8,751.8,1208.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st26",
    cx: 796.5,
    cy: 1211.2,
    rx: 1.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st26",
    cx: 820.1,
    cy: 1211.2,
    rx: 1.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M815.1,1198.5c2.9-1,7-0.8,9.9,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M797.9,1198.2c-3.2-1.4-9-1.1-11.8,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M808.6,1209.5c0.8,2.9,0.2,6.5-0.7,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M806.5,1226.6c-3.8,0.7-10.6-1.4-12.4-4.5"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M820.1,1259.5l12.7-7.7c0,0,10.7,0.9,18,14.3c7.2,13.3,20.9,56.3,25.2,58.2s56.6,2.6,56.6,2.6l0.7,15.3 c0,0-64.1,10.2-71.8,6c-7.7-4.2-32.4-53.8-32.4-53.8L820.1,1259.5L820.1,1259.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M819.3,1257.8l2.5-8.6c0,0,14.1,0.6,21.3,6.2s13.1,21,13.1,21l-18.3,29.5L819.3,1257.8L819.3,1257.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M841,1317c0,0,19.6-17,22.7-21.2c1.5-2.1,12.1,22.6,10.3,25.6c-2.9,4.8-20.8,16.4-21.8,15.7 C851.2,1336.4,841,1317,841,1317z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M835.9,1301.5c5.9-9.4,11.8-18.8,17.8-28.2c0.3-0.5,0.7-1.1,1.2-1.4c1.5-1,3.6,0.2,4.2,1.9 c0.6,1.7,0.2,3.5-0.3,5.2c1.9-0.3,3.6,1.6,3.8,3.5s-0.6,3.8-1.5,5.5c-5.5,10.4-14.7,18.7-25.5,23.2 C835.1,1307.9,834.1,1304.4,835.9,1301.5L835.9,1301.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M924.5,1329.2c7.3-5.2,21.5-15.4,22.6-15.8c1.3-0.6,9.9-0.6,14.6,0.8c4.7,1.4,9.1,4.7,10.8,9.3 c0.5,1.3,0.6,3-0.5,3.8c-0.7,0.5-1.8,0.3-2.5-0.1c-0.7-0.4-1.3-1.2-2-1.8c-3.1-3.4-6-4.8-11.1-5c6.1,0.9,10,4.7,11.8,10.6 c0.4,1.2,0.5,2.7-0.5,3.5c-0.8,0.6-1.9,0.4-2.7-0.1s-1.4-1.4-2-2.1c-2.2-2.8-5.2-5.1-8.6-6.4c4.7,2,8.2,6.5,8.9,11.6 c0.1,0.7,0.2,1.5-0.1,2.2c-0.3,0.7-1,1.2-1.7,1.1c-0.6-0.1-1-0.6-1.4-1c-2.5-2.9-4.5-5.9-7.9-8c3.1,4.1,5.7,10.8,5,12.5 c-0.2,0.5-1.5,1.4-3,0c-1.7-1.7-2.8-4.5-5.4-7.7c-4.4,5-11.6,7.2-18.1,5.8C928.5,1337.8,926.5,1333.4,924.5,1329.2 L924.5,1329.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M937.9,1322.7c5.2-1.9,10.5-3.5,15.9-4.8c0.7-0.2,1.5-0.3,2.2-0.3s1.5,0.5,1.8,1.1 c0.3,0.7,0.1,1.5-0.3,2.1s-1.1,1.1-1.7,1.5c-2.3,1.4-4.7,2.6-7.2,3.8c-0.5,3.8-3.3,7.2-7,8.5"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M808,1247.8c3,2.7,5,17.6,6.6,27.1c2.3,14.2,14.3,76.1,15,80.5c1.3,7.7,25.8,7.2,26.7,3.2 c0.2-0.7-7.2-4.2-8.3-9.1c-1-4.4-9.2-90.6-13.1-95.1C829.8,1248.4,807,1246.9,808,1247.8L808,1247.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M774.4,1247.8c2.5,0.9,10.6,18,14.4,33.5c8,32.6,3.2,80.9,0,87.3c-3.2,6.4-34.5,9.2-39.8,7.5 c-3.1-1-6.4-98.5-4.3-110.7C746.1,1257.3,773.6,1247.5,774.4,1247.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M821.2,1356.7c6.6-2.4,25.7-7.4,28.3-7.2c2.7,0.3,5.4,1.2,7.1,3.5c1.1,1.4,1.6,3.2,2.1,5 c0.8,2.8,1.6,5.7,2.4,8.6c0.3,1,0.6,2,0.4,3.1s-0.9,2-1.8,2.1c-1.4,0.1-2.2-1.5-2.7-2.9c-1.3-3.5-2.6-7.1-3.8-10.6 c0.8,4.4,1.7,8.8,2.5,13.2c0.2,1,0.4,2.1,0.2,3.1s-1,2-2,2c-1.5,0-2.2-1.9-2.5-3.4c-0.7-3.4-1.5-6.9-2.6-10.3 c1.5,4.8,1.7,10.1,0.6,15c-0.2,0.8-0.4,1.6-0.9,2.1s-1.4,0.7-2,0.2c-0.4-0.4-0.5-1-0.6-1.6c-0.4-4.4-0.9-8.9-1.3-13.3 c0.4,4.7,0.8,9.5-0.5,13.9c-0.2,0.8-0.5,1.6-1.1,2.1s-1.5,0.7-2.1,0.2s-0.7-1.4-0.7-2.2c-0.1-2.8-0.2-5.6-0.2-8.8 c-2.5,2.9-5.8,4.8-9.4,5.3s-7.3-0.3-10.9-1.4C820,1369.3,820.3,1364.1,821.2,1356.7L821.2,1356.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M772.4,1276.9c-2-9.2-10.3-24.2-17-21.1c-3.9,1.8-15,5.5-15,29.9c0,33,4.3,76.3,15,83.6 c5.4,3.7,64.7,7.3,64.7,7.3l4.3-21.2c0,0-43.7-8.1-45.7-14.1C775.9,1332.9,777.7,1301.5,772.4,1276.9L772.4,1276.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M767.2,1271.9c7.3,24.8,8.9,67,10,69.5c1,2.3,6.6,3.3,10.9,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M775.6,1373.1c-8.1-0.8-18.2-2.4-20.5-4.1c-2.7-2-5.9-11.7-8.2-18.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M774.4,1312.9c2.9-3.7,4.1-9.7,4.4-17.2"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 990.9,
    y: 1523.2,
    className: "st11",
    width: 105.1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1008.9,1435.1c0,0.2,0,0.5-0.1,0.7l-1.6,13.1l-14.5,116.9c-0.4,3.1-3.2,5.4-6.4,5 c-2.9-0.4-5-2.8-5-5.7c0-0.2,0-0.5,0.1-0.7l14.3-115.5l1.8-14.5c0.4-3.1,3.2-5.4,6.4-5 C1006.8,1429.8,1008.9,1432.3,1008.9,1435.1L1008.9,1435.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1008.9,1435.1c0,0.2,0,0.5-0.1,0.7l-1.6,13.1h-11.5l1.8-14.5c0.4-3.1,3.2-5.4,6.4-5 C1006.8,1429.8,1008.9,1432.3,1008.9,1435.1L1008.9,1435.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1050.6,1434.1v131c0,3.2-2.5,5.7-5.7,5.7c-1.6,0-3-0.6-4-1.7c-1-1-1.7-2.4-1.7-4v-131 c0-3.2,2.6-5.7,5.7-5.7c1.6,0,3,0.6,4,1.7C1050,1431.1,1050.6,1432.5,1050.6,1434.1L1050.6,1434.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1049,1430.1c1,1,1.7,2.5,1.7,4v14.8h-11.4v-14.8c0-3.2,2.6-5.7,5.7-5.7 C1046.5,1428.4,1047.9,1429,1049,1430.1L1049,1430.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1108.1,1565.1c0,2.8-2.1,5.3-5,5.7c-3.1,0.4-6-1.8-6.4-5l-14.5-116.9l-1.6-13.1 c0-0.2-0.1-0.5-0.1-0.7c0-2.8,2.1-5.3,5-5.7c3.1-0.4,6,1.8,6.4,5l1.8,14.5l14.3,115.5 C1108.1,1564.6,1108.1,1564.8,1108.1,1565.1L1108.1,1565.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1093.7,1448.9h-11.5l-1.6-13.1c0-0.2-0.1-0.5-0.1-0.7c0-2.8,2.1-5.3,5-5.7c3.1-0.4,6,1.8,6.4,5 L1093.7,1448.9L1093.7,1448.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1118.5,1419.1v3.8c0,6.7-5.4,12.1-12.1,12.1H998.5c-6.7,0-12.1-5.4-12.1-12.1v-3.8 c0-6.7,5.4-12.1,12.1-12.1h107.9C1113.1,1407,1118.5,1412.4,1118.5,1419.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1118.5,1419.1v3.8c0,6.7-5.4,12.1-12.1,12.1h-97.9c-6.7,0-12.1-5.4-12.1-12.1v-3.8 c0-6.7,5.4-12.1,12.1-12.1h97.9C1113.1,1407,1118.5,1412.4,1118.5,1419.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M977.1,1246.8c2.2-3.5,0.1-8.2,0.7-12.3c0.2-1.1,0.7-2.3,1.6-3c0.9-0.7,2.3-0.8,3.2,0 c1,1,0.7,2.6,0.7,4c0,2.5,1.2,4.9,1.7,7.4c1.3,6-1.9,11-5,16.2c-3.8,2.7-9,4.5-12.2,4.8c-2,0.2-12.4-5.5-16.5-17.8 c-2-6.2-1.8-8.7-1.1-9.6c0.7-0.9,2-1.2,2.9-0.6c0.5,0.4,0.8,1,1,1.7c1.3,3.7,2.6,7.4,3.8,11.2c-5-4.7-7.8-11.6-7.4-18.5 c0.1-1.3,0.5-2.9,1.7-3.3c0.8-0.3,1.7,0.1,2.3,0.7c0.6,0.6,1,1.4,1.3,2.1c1.8,3.9,3.6,7.8,6.1,12.4 c-4.6-4.3-6.5-11.2-4.9-17.3c0.3-1,0.9-2.2,2-2.2s1.7,1.2,2.1,2.2c1.8,4.9,3.7,9.8,5.5,14.7c-2.6-4.1-3.7-9.1-3.1-13.9 c0.2-1.7,1.1-3.8,2.9-3.9c1,0,1.9,0.6,2.5,1.5s0.7,1.8,1,2.8C971.3,1231.8,973.8,1237.1,977.1,1246.8L977.1,1246.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M951.4,1236c1.6-0.4,2.8,0.1,3.4,2.5c0.9,3.3,3.2,11,5.7,12.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "980.6,1256 986.5,1269.9 970.7,1279.5 963.7,1260.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M979.9,1239.6c-1.1-6.4-6-11-11.4-11.6l-0.1-0.4c0,0-2.9,0.5-3.8,0.7c-6.2,1.4-10.1,8.4-8.8,15.7 c1.3,7.2,7.3,12.5,13.7,11.6c1-0.1,3.8-0.6,3.8-0.6l-0.1-0.4C978.1,1252,981,1246,979.9,1239.6L979.9,1239.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M968.1,1227.6c6.7-1.2,13.2,4,14.5,11.5c1.3,7.6-3,14.7-9.6,15.8c-6.7,1.2-13.2-4-14.5-11.5 C957.1,1235.8,961.5,1228.7,968.1,1227.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M979.9,1239.6c-1-5.8-6-9.8-11.2-8.9c-0.1,0-0.2,0-0.3,0.1c-5,1-8.2,6.4-7.2,12.1 c1,5.7,5.9,9.7,10.9,8.9c0.1,0,0.2,0,0.3,0C977.6,1250.9,980.9,1245.4,979.9,1239.6L979.9,1239.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1029,1252.3l-9.7-7.4c0,0-6.3,3.6-9.7,11.1s-7.9,32.6-7.9,32.6l-18.2-30.2l-23.1,16.4 c0,0,25.7,65,41.1,65.8c15.4,0.8,26.3-13.5,26.3-13.5L1029,1252.3L1029,1252.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "952.4,1533.1 955.3,1551.8 967.5,1556.7 981.5,1550 978.9,1531.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M989.4,1574.6l-63.2-0.9c0,0-0.4-1.3-0.6-3.2c-0.3-3,0.2-7.4,3.9-10.3c5.3-4.1,13.7-4.7,19.2-6.8 c3.3-1.3,5.3-4.5,5.3-4.5l9,0.5c0,0,0.7,5,4.1,4.7s14.4-5.7,14.4-5.7c5.7,9.8,7.4,17.6,7.8,22.1 C989.5,1573.1,989.4,1574.6,989.4,1574.6L989.4,1574.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M989.4,1574.6l-63.2-0.9c0,0-0.4-1.3-0.6-3.2h63.6C989.5,1573.1,989.3,1574.6,989.4,1574.6 L989.4,1574.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1027.9,1533.1 1030.8,1551.8 1043,1556.7 1057,1550 1054.5,1531.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M1064.9,1574.6l-63.2-0.9c0,0-0.4-1.3-0.6-3.2c-0.3-3,0.2-7.4,3.9-10.3c5.3-4.1,13.7-4.7,19.2-6.8 c3.3-1.3,5.3-4.5,5.3-4.5l9,0.5c0,0,0.7,5,4.1,4.7c3.3-0.3,14.4-5.7,14.4-5.7c5.7,9.8,7.4,17.6,7.8,22.1 C1065,1573.1,1064.9,1574.6,1064.9,1574.6L1064.9,1574.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M1064.9,1574.6l-63.2-0.9c0,0-0.4-1.3-0.6-3.2h63.6C1065,1573.1,1064.9,1574.6,1064.9,1574.6 L1064.9,1574.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M1024.2,1349.1l-10.3,16.8c0,0-59.2,9-68.8,23.5c-8.8,13.4,3.1,149,3.1,149h40.7 c0,0-3.1-100.2,0-109.5c3.1-9.3,96.4-8.8,101.7-21.3c5.3-12.6,7.1-56.7,7.1-56.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M1099.3,1368.5c0,0,2.3,36.3-9.6,45c-10.4,7.5-36.7,9.5-36.7,9.5l5.1,112.9l-38.9,2.5 c0,0-19.3-131.8-18.4-144.5c0.9-12.6,38.3-21.8,35.8-23.6c0,0-28.8-9.8-18.2-20.5c0.2-0.2,0.5-0.5,0.8-0.7 c2.5-2.2,32.9,0.1,32.9,0.1l28-2.6l11.1,12.6L1099.3,1368.5L1099.3,1368.5z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M1097.9,1379.9c-0.2,1.8-0.5,3.7-0.8,5.6c-4.8-6.1-12.5-15-19.4-18.8c-14.2-7.8-59.5-13.1-59.5-13.1 l0.2-3.9c0.2-0.2,0.5-0.5,0.8-0.7c2.5-2.2,32.9,0.1,32.9,0.1l28-2.6l11.1,12.6L1097.9,1379.9L1097.9,1379.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1079.1,1234.1c0,0-16.7,21.5-27.1,20.4s-18.5-12.6-18.5-12.6s4.2-1.5,6-8.3c1.1-3.9,1.3-9.6-0.5-17.8 l30.9-4.6c0,0-0.2,5.2,1.2,10.7C1072.2,1226.7,1074.5,1231.7,1079.1,1234.1L1079.1,1234.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1039.5,1233.6c1.1-3.9,1.3-9.6-0.5-17.8l30.9-4.6c0,0-0.2,5.2,1.2,10.7 C1062.7,1228.9,1051.3,1233.2,1039.5,1233.6L1039.5,1233.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1010.7,1197.6c0.5-4.2,5.5-7,11.2-6.4c5.7,0.7,10,4.6,9.5,8.7c-0.5,4.2-5.5,7-11.2,6.4 S1010.2,1201.7,1010.7,1197.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M1022.4,1198.7L1022.4,1198.7c0-1.5-1.1-2.6-2.5-2.6h-1.4c-1.4,0-2.5,1.1-2.5,2.5v0.1 c0,1.4,1.1,2.5,2.5,2.5h1.4C1021.3,1201.1,1022.4,1200,1022.4,1198.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1016.1,
    y: 1198.6,
    className: "st42",
    width: 2.1,
    height: 5.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1080.4,1186.8c0-19.7-13.6-35.7-30.5-35.7s-30.5,10.5-30.5,35.7c0,19.7,7.7,36.8,25.8,38 C1062,1225.9,1080.4,1206.5,1080.4,1186.8L1080.4,1186.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1076.8,1196.1c-5.6-5.4-9.7-12.2-11.7-19.8c-2.8,0.9-6.1,0.3-8.2-1.2c-6.2,2.5-13.5,2-19.2-1.1 c-4.4,2-9.7,2-14.2-0.4c-2.1,2.9-3.7,6.2-4.7,9.7c0.4-6.8,0.9-13.6,1.3-20.4c16.1-2.3,32.2-3.8,48.5-4.7 c0.9-0.1,1.9-0.1,2.7,0.3c1.2,0.6,1.7,2,2.1,3.4C1076.8,1173,1078.6,1184.8,1076.8,1196.1L1076.8,1196.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M1084.5,1160.6c-0.7,10.1-1.3,23.2-2,33.2c-0.9,3.4-3.9,3.3-7.9,4.6c-3.7-8.3-6-17.2-7.4-27 c-3.9,1-8.1,0.7-12.1-0.8c-6,2.3-12.7,2.4-18.8,0c-4.6,1.5-9.7,1.8-14,0.3c-1.6,5-2.4,12.5-2.9,17.8 c-0.6-4.9-2.5-19.9-2.9-30.2c-0.2-4.4-0.2-8,0.4-9.5c1.9-5.6,8.1-3.8,9.8-1.9c1.1-2.6,3.5-4.6,6.3-5.2 c2.8-0.6,5.8,0.1,8.3,2c1.7-3.2,5.3-5.4,8.9-5.5c3.7-0.1,7.3,2,8.6,5.5c1.7-0.9,3.5-1.8,5.4-2.2s4-0.2,5.6,0.9 c0.8,0.5,1.5,1.2,2,2.1c0.6,0.9,0.9,2,1.1,3.2c1.5-2.2,4.8-2.5,7.1-1.3c2.3,1.2,3.8,3.7,4.4,6.3 C1084.9,1155.3,1084.7,1158,1084.5,1160.6L1084.5,1160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M1071.7,1144.5c-2-0.9-4.3-1.1-6.5-0.6c-2.7,0.6-5.2,2.3-6.5,5c-1.3-3.4-4.9-5.8-8.5-5.6 c-3.6,0.2-7,2.9-8.7,7.2c-1.9-2.3-5.1-3.6-8.1-3.2c-3,0.4-5.8,2.3-7.1,5.3c-1-1.2-2.9-1.5-4.4-0.9s-2.7,1.8-3.6,3.1 c-0.8,1.1-1.3,2.3-1.8,3.6c-0.2-4.4-0.2-8,0.4-9.5c1.9-5.6,8.1-3.8,9.8-1.9c1.1-2.6,3.5-4.6,6.3-5.2c2.8-0.6,5.8,0.1,8.3,2 c1.7-3.2,5.3-5.4,8.9-5.5c3.7-0.1,7.3,2,8.6,5.5c1.7-0.9,3.5-1.8,5.4-2.2s4-0.2,5.6,0.9 C1070.5,1142.9,1071.2,1143.6,1071.7,1144.5L1071.7,1144.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M1031.8,1185.2c-2.6-0.6-5.5-0.1-7.8,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M1051.9,1185.8c2.8-1.2,6.3-0.9,8.9,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M1039.7,1196.7c0.1,2.8,0.4,5.6,0.8,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M1043.7,1212.9c3.4,0.1,6.9-1.2,9.4-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M1053,1196c0.9-0.2,1.7,0.6,1.9,1.8c0.2,1.1-0.3,2.2-1.2,2.3s-1.7-0.6-1.9-1.8 C1051.6,1197.2,1052.1,1196.2,1053,1196z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M1029.1,1196.4c0.9-0.2,1.7,0.6,1.9,1.8c0.2,1.1-0.3,2.2-1.2,2.3s-1.7-0.6-1.9-1.8 C1027.7,1197.5,1028.3,1196.5,1029.1,1196.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1077.7,1191.2c5.7-0.8,10.8,2,11.4,6.1s-3.6,8.2-9.3,9c-5.7,0.8-10.8-2-11.4-6.1 C1067.9,1196,1072,1192,1077.7,1191.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M1077.4,1198.7L1077.4,1198.7c0-1.5,1.1-2.6,2.5-2.6h1.4c1.4,0,2.5,1.1,2.5,2.5v0.1 c0,1.4-1.1,2.5-2.5,2.5h-1.4C1078.5,1201.1,1077.4,1200,1077.4,1198.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.7,
    y: 1198.6,
    className: "st42",
    width: 2.1,
    height: 5.7
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M1075.3,1229.3c0,0-16.9,10.2-19.8,13.9c-2.9,3.7-3.8,8.7-3.8,8.7s-4-8.5-5-9.3c-1-0.8-8-7.4-8-7.4 l-8.3,6.3l-11.1,5.8l0.5,107l75.4,5.1l1.9-116.1L1075.3,1229.3L1075.3,1229.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M1051.6,1252.5c-3.6,30,2.6,82.5-7.4,102.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M1053,1247.5c0,0,1.3-4.7,4.2-7.1c2.9-2.3,18-11.2,18.4-11.3s7.8,5.1,7.8,5.1l-11.2,15.9 c0,0-11.5-8.1-14.2-7.4C1055.5,1243.3,1053,1247.5,1053,1247.5L1053,1247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M1049.5,1247.5c0,0-0.9-3.3-2.4-5.2c-1.8-2.2-7.6-8.5-8.2-8.5s-6.5,3.6-7.6,5.8 c-1.1,2.2-0.5,12.3-0.5,12.3s10-9.5,13.9-8.5C1047.4,1244.2,1049.5,1247.5,1049.5,1247.5L1049.5,1247.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1081.8,1232.3c0,0-13.1,12.3-15.1,24.8s-1.2,78.2,10.9,100c10.5,19,11.5,79.3,11.5,107.4l36.8-12.7 c0,0-0.2-50.3-12-96.9c-9.2-36.1-0.4-102-5.6-108.5C1104.6,1241.9,1081.8,1232.3,1081.8,1232.3L1081.8,1232.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M1066.3,1302.4c0,0-3-34.7-0.1-45.9c2.9-11.2,11.4-25.4,13.7-25.9c3.8-0.8,12.3,5.8,12.3,5.8 s-6.9,11.9-8.9,30c-0.2,1.6-13.7,6.6-13.7,6.6s10.5,7.7,10.4,8.5C1079.9,1282.2,1066.3,1302.4,1066.3,1302.4L1066.3,1302.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st37",
    cx: 1042.2,
    cy: 1361.5,
    rx: 14.3,
    ry: 8.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1061.8,1349.9l-14.5-1.9c-1.3-0.2-2.7-0.3-3.9,0.2c-1.6,0.8-2.4,2.7-2.5,4.6c2.4,0.2,4.8,0.4,7.3,0.8 c-3,4.1-6.6,7.7-10.7,10.6c-0.9,0.7-1.9,1.3-2.5,2.2c-0.7,0.9-1.1,2.1-0.7,3.2c0.4,1.1,1.4,1.8,2.5,2c1.1,0.2,2.2,0,3.5,0.1 c-0.4,1.6,0.4,3.4,1.9,4.2c1.5,0.8,3.4,0.5,4.8-0.6c0.7,1.4,2.2,2.4,3.8,2.6c1.6,0.2,3.2-0.3,4.6-0.7 c1.1,1.3,2.9,2.1,4.6,2.1c1.8,0,3.5-0.9,4.9-2.1c4.2-3.7,7.6-8.5,9.7-13.7C1069.9,1359.3,1065.6,1354.8,1061.8,1349.9 L1061.8,1349.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1085.3,1259.7c-0.4-6.9,3.1-19.9,8.1-21.2c7.7-2.1,20.9,9.5,24.3,18.8c3.5,9.2,13.9,65.9,11,73.6 c-4,10.5-57,38.8-57,38.8l-16.4-24c0,0,36.7-19.9,38.9-26.2C1095.5,1315.5,1086.1,1275.9,1085.3,1259.7L1085.3,1259.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1103,1247.8c0,0-5.9,7.8-5.9,21.7s3.4,47,2.6,48.2c-0.8,1.2-26.7,18-26.7,18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1097.5,1290.6c-3.9-4.6-6.6-10-7.8-15.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1083.5,1364c8.4-4.6,20.6-11.7,27.9-17.6"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1036.6,1234.7c0,0-2.2,8.6-2.2,23.4c0,25-3.2,94.4-16.4,104.6c-10.3,8.1-23.3,7.5-29.2,7.5 c0,0,12.2-6.5,16.8-14c5.1-8.4,5.9-35,6.6-49c0.7-14.7,2-55.3,3.7-58.8C1019.6,1240.9,1036.6,1234.7,1036.6,1234.7 L1036.6,1234.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M1032.3,1304.5c0,0,3-23.5,3-39.8c0-18.3,3-30.9,3-30.9s-10.4,3.3-11.5,5c-1.1,1.7-6.5,11.3-9.3,29.7 c-0.5,3,11.8,5.5,11.8,5.5s-9.5,7.3-9.5,9.2C1019.9,1286.7,1032.3,1304.5,1032.3,1304.5L1032.3,1304.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1015.4,1255.8c0,39.8-3.6,71.7-5.3,82.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1009.7,1270.1c1,5.7,3.5,11.3,5,13.1"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M1017,1204.2c0,0,2,45.9,29.5,47.7c23.2,1.5,36.1-27.1,36.1-47.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M1048.3,1252.5c0,0-16.9,61.9-63.9,73.1c-57.5,13.7-113.8-1.7-113.8-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M972.4,1254.2c0,0,6.5,37.5-22.6,57c-25.8,17.2-79.2,11.9-79.2,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M1028.9,1361.3c0,0-105.4,0.2-159.1-37.4"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M1249.5,1097.1c-0.6-11.2,7.5-22.4,18.4-25.1s23.4,3.2,28.2,13.4c4.1,8.7,2.7,19,0.7,28.4 c-1.9,9.4-4.4,19.2-2.2,28.6c1.9,7.9,7,14.8,8,22.9c1.4,11.1-6.4,22.6-17.2,25.4c-6.1,1.6-14-0.4-15.9-6.4 c-1.8-5.6,2.3-11.5,1.5-17.3c-0.7-4.8-4.7-8.5-7.9-12.1C1251.1,1141.4,1250.9,1121.9,1249.5,1097.1L1249.5,1097.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1144.7,1239.2c-5.5-6.2-9.5-17.5-9.5-21.2c0-4.5-0.7-9,0.9-13.2c0.8-2.2,2-4.1,3.3-6 c1.4-2.2,2.8-4.4,4.2-6.6c0.6-0.9,1.3-1.9,2.3-2.2c1.8-0.5,3.4,1.5,3.3,3.3c-0.1,1.8-1.3,3.3-3.4,5c0.8-3.3,2.5-6.4,4.8-8.9 c0.6-0.7,1.4-1.3,2.3-1.1c1.4,0.3,1.4,2.4,1,3.8c-1,3.6-1.9,7.2-2.7,10.2c3.1,5.8,2.8,12.7,2.8,19.3c0.1,6.6,0.7,13.7,5,18.6 C1155,1241.9,1150.1,1234.7,1144.7,1239.2L1144.7,1239.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1144.1,1238.4c0,0,14.5,49.5,25.4,50.5c13.2,1.2,24-11,24-11l8.7-44.3l-19.6-11.7l-10.8,35.5l-15.4-17.5 L1144.1,1238.4L1144.1,1238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M1209.3,1241c-10.8-4.1-21.6-8.1-32.4-12.2c2.9-14.1,7-31,10.6-36.3c6.7-10.1,17.5-10.6,17.5-10.6 l4.9,14.6l-0.6,44.3C1209.3,1240.7,1209.3,1240.8,1209.3,1241L1209.3,1241z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "1199.4,1269.7 1167.8,1188.2 1129.2,1198.2 1164.9,1288.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "1194.1,1265.2 1165.7,1192.6 1134.2,1201.2 1165.2,1280.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "1155.6,1190.7 1157.5,1195.9 1145.2,1199.4 1143,1194  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M1180.7,1564.3c0.1,5.3,56.2,3.5,58.8-0.9c1.6-2.9-1.4-10.1-3.7-14.8c-1.2-2.5-2.2-4.3-2.2-4.3l-7.1-10 l-5.7-0.2c-12.6,7.3-25.2,15.2-32.8,21.4C1183.4,1559.2,1180.7,1562.3,1180.7,1564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1187.9,1555.6c11.6,7.3,38.3-2.9,47.9-7c-1.2-2.5-2.2-4.3-2.2-4.3l-7.1-10l-5.7-0.2 C1208.1,1541.4,1195.5,1549.3,1187.9,1555.6L1187.9,1555.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "1205.1,1512.1 1207.1,1534 1207.8,1541.8 1208.3,1547.2 1231,1544.9 1231.2,1541 1231.2,1541  1231.4,1537 1232.6,1511.2 1232.8,1508.6 1218.9,1510.4  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "1205.1,1512.1 1207.1,1534 1218.5,1535.4 1218.5,1535.4 1228.1,1536.6 1231.4,1537  1232.6,1511.2 1218.9,1510.4  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M1189.1,1293.3c0,0-9.8,27-7.8,65.4c1.9,38.4,18.1,172.2,18.1,172.2l40.3-1.9l-6.9-172.8l-9.7-53.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M1281.6,1563.7c3.6,4,45.1-33.8,44.2-38.8c-0.6-3.2-7.6-6.8-12.4-8.9c-2.6-1.1-4.5-1.8-4.5-1.8l-11.9-3 l-4.4,3.6c-4.9,13.7-9.3,27.9-11.1,37.6C1280.4,1558.1,1280.3,1562.3,1281.6,1563.7L1281.6,1563.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1281.4,1552.4c13.6-2,27.3-27.1,31.9-36.4c-2.6-1.1-4.5-1.8-4.5-1.8l-11.9-3l-4.4,3.6 C1287.6,1528.6,1283.2,1542.8,1281.4,1552.4L1281.4,1552.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "1266.4,1508.2 1275.8,1517.4 1287.7,1529.1 1291.6,1532.9 1307.3,1516.3 1304.9,1513.3  1298.1,1504.5 1285.1,1487.6  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "1266.4,1508.2 1275.8,1517.4 1298.1,1504.5 1285.1,1487.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M1183.7,1318.7c3.9,10.9,33.5,30.1,33.5,30.1s-0.3,76.1,0.8,95.3c1.1,19.2,40.8,81.8,40.8,81.8l37.2-33.1 c0,0-28.9-48.3-30.8-59.6c-2-11.4,10.5-71,10.5-95.3c0-4.5-0.4-9.1-1.1-13.7c-1.5-10.1-4.2-20-6.6-27.4 c-2.4-7.3-4.4-12.2-4.4-12.2s-20.2,2.9-40.4,8.6c-18.5,5.2-36.9,12.6-39.7,22.1C1183.2,1316.3,1183.3,1317.4,1183.7,1318.7 L1183.7,1318.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M1183.7,1318.7c9.8,5.8,20.1,10.9,30.7,15.3c0.7-1.8,1.3-3.5,2.2-5.3c0.9,2,1.9,4,3,6.7 c18.2-4.6,36.6-8.4,55-11.3c-1.5-10.1-4.2-20-6.6-27.4c-14.9-1.4-29.9-2.6-44.8-3.6c-18.5,5.2-36.9,12.6-39.7,22.1 C1183.2,1316.3,1183.3,1317.4,1183.7,1318.7L1183.7,1318.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M1287.1,1193.7c-1.4-8.6-33.8-19.6-44.8-18.6c-23.7,2.2-40.8,6.5-46.2,9.8c-5.4,3.3-10.3,35-10.3,43.8 c0,10.4,3.6,30.9,2.6,39.1c-1.8,16-11.6,49.9-11.6,49.9l35.7,12.5l4.4-7.8l4,9.9l58.9-13.5c0,0-4.5-46.9-4.5-55.2 C1275.4,1255.7,1288.9,1204.7,1287.1,1193.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M1232.1,1199.2c-11.8,61.7-12.5,79.3-15.2,122.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st59",
    cx: 1233.7,
    cy: 1211.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st59",
    cx: 1228.7,
    cy: 1238.4,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st59",
    cx: 1224.9,
    cy: 1266.9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st59",
    cx: 1222.9,
    cy: 1299.5,
    r: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M1163.3,1237.4l5.9,0.5h0.5l39.6-10.4c2.7-1.4,3.2-3.7,2.5-5.5c-0.8-2.2-3.5-3.3-5.7-2.5l-37.8,13.3 l-0.4,0.3L1163.3,1237.4L1163.3,1237.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M1163.3,1237.4l1.6,0.1l4.3,0.3c-0.1-0.1-0.3-0.2-0.4-0.3c-0.5-0.5-0.8-1.2-0.6-1.9 c0.1-0.3,0.3-0.6,0.1-0.9c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.3-0.3-0.8-0.2-1.2l-3.4,3.1L1163.3,1237.4L1163.3,1237.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M1163.3,1237.4l1.6,0.1c-0.2-0.2-0.3-0.4-0.4-0.6c-0.1-0.2-0.1-0.4-0.1-0.6L1163.3,1237.4 L1163.3,1237.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1210.1,1246.2c-3.9-7.2-7.8-14.4-11.9-21.7c-3.1-2.4-6.6-4.2-10.1-5.6c-4.2,1.4-8.2,3.9-11.5,7.3 c-0.8,0.8-1.6,2-1.3,3.2c0.3,0.8,1.1,1.2,1.9,1.2c0.8-0.1,1.5-0.5,2.2-0.9c2.2-1.3,4.3-2.5,6.8-3.7c0.7,0.6,1.4,1.2,1.9,1.8 c-1.5,0-2.9,0-4.7,0.5c-2.8,1.3-5.5,2.8-8.2,4.5c-0.7,0.5-1.6,1.1-1.6,2c-0.1,0.8,0.4,1.5,1,1.8c0.6,0.3,1.3,0.3,2,0.3 c2.5-0.2,5-1.1,7-2.6c0.8,0.2,1.7,0.5,2.3,0.9c-1.1,0.2-2.1,0.4-3.1,0.9s-1.9,1.3-2.3,2.5c-0.4,1.1-0.3,2.5,0.3,3.7 c-0.6,0.2-0.9,1-0.9,1.6s0.3,1.3,0.6,1.8c0.6,1.2,1.3,2.4,2,3.5c0.7,1,1.5,2.1,2.6,2.5s2.5,0.1,3.3-1.2 c2.9,5.1,8.4,8.1,13.8,7.5C1205.5,1254.6,1208.2,1250.6,1210.1,1246.2L1210.1,1246.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1193.1,1228.6c-1.4-0.6-2.9-0.8-4.4-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1190.3,1234.8c-1.4-0.1-2.8-0.1-3.9,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1181.1,1241.9c2-1.1,5.3-1.7,7.5-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1187.9,1250.2c-0.7-1.1-1.3-3-1.6-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1186.8,1248.2c-0.9,0.1-1.8,0.3-2.6,0.2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1199.9,1256.2c0,0,49.3,41.8,62.6,37.1c5.3-1.9,10.5-17.2,14.3-31.5c3.5-13.1,5.8-25.4,5.8-25.4 l-27.9-11.8c0,0-1.9,12.7-3.8,23c-1.2,7-2.5,12.8-3.2,13c-2.8,0.8-39.1-15.3-39.1-15.3L1199.9,1256.2L1199.9,1256.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M1251,1247.6c6.7,4.4,17.1,10.8,25.9,14.2c3.5-13.1,5.8-25.4,5.8-25.4l-27.9-11.8 C1254.7,1224.6,1252.9,1237.3,1251,1247.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M1282.7,1251.3c-12.2-2.3-21.9-4.3-33.6-8.5c1.7-13.7,5.5-38.5,8.7-46.2c2.2-5.4,11-15,20.8-10.8 c9.8,4.2,13.6,10.6,12.6,27.8C1290.8,1219.7,1285,1238.9,1282.7,1251.3L1282.7,1251.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1223.1,1181.3c0,0,2.9,13,8.4,16.8c5.5,3.8,26.5-19.5,26.5-19.5c-3.6-3.4-4.5-10-4.4-15.8 c0-6,1-11.1,1-11.1l-25.5,7.4c0.3,6.3-0.3,10.9-1.1,14.1C1226.2,1180.2,1223.1,1181.3,1223.1,1181.3L1223.1,1181.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M1228,1173.2c11.8,2.5,20.8-5,25.5-10.4c0-6,1-11.1,1-11.1l-25.5,7.4 C1229.3,1165.4,1228.8,1169.9,1228,1173.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M1232.4,1198.6c-0.3-0.1,1.3-8.8,2.1-9.6c0.8-0.8,21-18.4,22.2-17.7c1.8,0.9,4.7,6.5,4.7,6.5 s-4.1,5.6-11.9,11.9C1244.1,1194.1,1235.5,1199.1,1232.4,1198.6L1232.4,1198.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M1232.4,1198.5c0.4-0.4-0.5-9.1-1-9.9c-1.7-2.6-4.5-9.5-4.5-14.2c0,0-5.1,1.9-5.7,3s2.1,9.4,4.3,13.3 C1229.1,1197.3,1232.1,1198.9,1232.4,1198.5L1232.4,1198.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1127 -0.9936 0.9936 0.1127 -59.8884 2211.2603)",
    className: "st60",
    cx: 1208.2,
    cy: 1139.2,
    rx: 7.8,
    ry: 10.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1268.6,1126.8c0-20.1-13.9-36.4-31.1-36.4s-31.1,16.3-31.1,36.4c0,20.1,8.6,40.1,26,39.4 C1249.6,1165.5,1268.6,1146.9,1268.6,1126.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M1261.7,1135.5c-3.6-3.9-5.9-11.3-6.4-14.5c-3.5-1-7.6-4.3-9.7-8.8c-5.3,5.3-25.3,8.2-31.9,6.5 c-4.8,5.9-4.9,8.8-6.6,16.3c-1.1-9.1-0.6-18.5,1.4-27.5c12.5-4,24.8-8.9,36.6-14.6c2-1,4.5-2,6.4-0.8 c1.2,0.7,1.9,2.1,2.5,3.4c2.7,5.5,6.5,10.4,11.2,14.2c1.2,1,2.6,2.2,2.7,3.7c0,1-0.5,2-1,2.9 C1264.6,1120.5,1265,1130.4,1261.7,1135.5L1261.7,1135.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M1201.2,1114.5c-0.1,7.6,6.1,23.4,6.1,23.4s0-13,6-21.5c12.3,0,25.9-0.6,33.4-7.6 c2.2,5.5,5.9,8.8,10.5,10.3c-0.1,6.9,3,13.4,5,19.2c3.9-2.3,6.8-1.4,9.9-5.1c1.8-6.8,3.8-17.3,3.2-23.8 c-0.5-5.2-1.9-10.6-4.7-15c-0.7-1.1-1.4-2.1-2.3-3c-4.4-4.9-11.3-7.7-17.7-6.1c-3.5-4.2-8.9-6.7-14.3-7 c-5.4-0.3-10.8,1.4-15.5,4.1c-9.2,5.2-16.4,13.3-18.8,24.6C1201.5,1109.5,1201.3,1111.9,1201.2,1114.5L1201.2,1114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M1201.2,1114.5c0.3-1,0.6-2,0.9-2.9c1.8-4.6,4.6-8.8,7.9-12.5c5-5.7,11.1-10.6,18.4-12.6 s15.7-0.7,21.1,4.5c6.8-2.9,15.2-1.3,21.1,3.5c-0.7-1.1-1.4-2.1-2.3-3c-4.4-4.9-11.3-7.7-17.7-6.1c-3.5-4.2-8.9-6.7-14.3-7 c-5.4-0.3-10.8,1.4-15.5,4.1c-9.2,5.2-16.4,13.3-18.8,24.6C1201.5,1109.5,1201.2,1112,1201.2,1114.5L1201.2,1114.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1266.7,1131.7c5.7-1.5,11.2,0.7,12.2,4.9c1.1,4.2-2.7,8.7-8.4,10.2c-5.7,1.5-11.2-0.7-12.2-4.9 C1257.3,1137.7,1261.1,1133.1,1266.7,1131.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st70",
    cx: 1239.7,
    cy: 1140.3,
    rx: 1.4,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st70",
    cx: 1214.8,
    cy: 1140.3,
    rx: 1.4,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1218.8,1127.2c-2.6-0.9-5.6-0.7-8,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1237.6,1128.3c2.9-1.3,6.5-0.9,9.1,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M1224.1,1142c-0.2,1.4-0.2,4.7,0,6.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M1225.6,1154.1c3.8,1.5,7.7,0.7,9.8-2.4"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st73",
    cx: 1109,
    cy: 1018.4,
    r: 52.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1135.7,992.1v35.9c0,8.8-4.4,16.9-11.8,21.8l-14.8,8.7l-13.6-8.8c-8.1-4.7-13.1-13.3-13.1-22.5v-34.9 l26.5-7.6l0.2,0.1L1135.7,992.1L1135.7,992.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M1135.7,992.1v35.9c0,8.8-4.4,16.9-11.8,21.8l-14.8,8.7v-73.8L1135.7,992.1L1135.7,992.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1102.9,
    y: 1001.2,
    className: "st31",
    width: 12.3,
    height: 40.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088.7,
    y: 1015.3,
    className: "st31",
    width: 40.6,
    height: 12.3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialitiesSectionArtMobile);
export default __webpack_public_path__ + "static/media/specialities-section-art_mobile.bc6550d118ca6905888d15565e34b779.svg";
export { ForwardRef as ReactComponent };